import React from 'react'
import { Link, animateScroll as scroll} from 'react-scroll'
import { NavLink } from 'react-router-dom'
import { navItems } from '../../../mock/header';
import TwitterSVG from '../../../assets/images/twitter.svg'
import './header.scss'
import { useEffect } from 'react';


const Header = ({ header, isSignedIn, connectAction }) => {

    useEffect(() => {
        if(window.location.hash) {
            setTimeout(() => {
                const anchor = document.querySelector(window.location.hash)
                scroll.scrollTo(anchor.offsetTop)
                history.replaceState('', document.title, window.location.origin + window.location.pathname + window.location.search);
            }, 100)
        }
    }, [])

    return (
        <div className={`header-wrapper ${header === 'transparent' && 'transparent_header'}`}>
            <h2 className='header-title'><NavLink to="/" className="nav_link">HASHRATE STUDIOS</NavLink></h2>
            <ul className='header-nav'>
                {
                    navItems.map(({title, anchor, link}) => (
                        <li key={title}>
                            {   window.location.pathname !== '/' ? (
                                    <NavLink to={anchor ? `/#${anchor}` : link} className="nav_link">{title}</NavLink>
                            ) :
                                anchor ? (
                                    <Link to={anchor} spy={true} smooth={true} duration={500}>{title}</Link>
                                ) : (
                                    <NavLink to={link} className="nav_link">{title}</NavLink>
                                )
                            }
                        </li>
                    ))
                }
            </ul>

            <div className='header-actions'>
                {/* <div className='header-button header-wallet' onClick={() => connectAction()}>
                    {isSignedIn ? "Logout" : "Connect wallet"}
                </div> */}

                <a 
                    className='header-button header-twitter'
                    target='_blank'
                    href='https://twitter.com/intent/follow?original_referer=https%3A%2F%2Fhashrate-studios.webflow.io%2F&ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Efollow%7Ctwgr%5EhashrateStudios&region=follow_link&screen_name=hashrateStudios'
                >
                    <img src={TwitterSVG} />
                    <span>Follow</span>
                </a>
            </div>
        </div>
    )
}

export default Header;